import { Form, Row } from "react-bootstrap";
import {
  Button,
  ButtonsContainer,
  DatePickerContainer,
  FormContainer,
  InputContainer,
  InputContainerMaisFiltros,
  MaisFiltrosContainer,
} from "./style";
import { Controller, useForm } from "react-hook-form";
import { DropdownSelect } from "components/DropdownSelect";
import { CustomInput } from "components/CustomInput";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEmpresas } from "hooks/useEmpresas";
import { MaisFiltros } from "components/ButtonModal";
import { CustomDatePicker } from "components/DatePicker";
import { useEffect, useState } from "react";
import { useFornecedores } from "../../../../../../Fornecedor/hooks/useFornecedores";
import { useMaskInput } from "hooks/useMaskInput";
import { CustomInputModal } from "components/CustomInputModal";
import { useProcessoFinanceiroAprovar } from "../../../../../hooks/useProcessoFinanceiroAprovar";
import { FiltrosReprovadosSchema } from "../../../../../validate/filtrosReprovadosSchema";
import { IFiltrosPagamentosReprovados } from "../../../../../interface/IFiltrosPagamentosReprovados";
import { useProcessoFinanceiroDescricao } from "hooks/useProcessoFinanceiroDescricao";

interface IProps {
  submitForm: (dados: IFiltrosPagamentosReprovados) => void;
}

export function FiltrosAguardando({ submitForm }: IProps) {
  const { register, handleSubmit, reset, control, setValue } = useForm({
    resolver: yupResolver(FiltrosReprovadosSchema),
  });

  const [inicioDataValidacao, setInicioDataValidacao] = useState<Date>();
  const [fimDataValidacao, setFimDataValidacao] = useState<Date>();
  const onChangeDataValidacao = (dates: any) => {
    const [start, end] = dates;
    setInicioDataValidacao(start);
    setFimDataValidacao(end);
  };
  const { optionsFornecedores, gerarOptionsFornecedores } = useFornecedores({
    semFiltroStatus: true,
  });
  const { mInputPlaca } = useMaskInput();
  const {
    processosFinanceirosDescricoesOptions,
    todosProcessosFinanceirosDescricoesOptions,
    listarOptions,
  } = useProcessoFinanceiroDescricao();

  useEffect(() => {
    gerarOptionsFornecedores();
  }, []);

  const { empresasOptions } = useEmpresas();

  const cancelarOnClick = () => {
    setValue("placa", "");
    setValue("idEmpresa", null);
    setValue("numeroNfRecibo", "");
  };

  const onClickLimpar = () => {
    setValue("placa", "");
    setValue("numeroNfRecibo", "");
    setValue("idsLotes", null);
    setValue("idsProcessos", null);
    setValue("idEmpresa", null);
    setValue("idFornecedor", null);
    setValue("periodoValidacao", [null, null]);
    setFimDataValidacao(undefined);
    setInicioDataValidacao(undefined);
  };

  const { validarProcessos, validarLotes } = useProcessoFinanceiroAprovar();
  const onChangeFornecedor = (idFornecedor: number) => {
    listarOptions(idFornecedor);
  };

  return (
    <FormContainer>
      <Form
        noValidate
        onSubmit={handleSubmit((dados: IFiltrosPagamentosReprovados) =>
          submitForm(dados)
        )}
      >
        <Row className="mb-4">
          <InputContainer width={"16%"}>
            <Form.Group>
              <Form.Label>ID Lote</Form.Label>
              <Controller
                control={control}
                name="idsLotes"
                defaultValue={[]}
                render={({ field: { onChange, value } }) => (
                  <CustomInputModal
                    label="Filtrar em massa"
                    value={value ?? []}
                    placeholder="Busque pelo lote"
                    onConfirm={onChange}
                    onClickOk={validarLotes}
                    validar={true}
                    style={{ width: "222px" }}
                    placeholderModal="Digite ou copie e cole os IDs dos lotes que deseja buscar e tecle ENTER"
                    labelItem="Recibo / NF"
                  />
                )}
              />
            </Form.Group>
          </InputContainer>
          <InputContainer width={"16%"}>
            <Form.Group>
              <Form.Label>ID Processo</Form.Label>
              <Controller
                control={control}
                name="idsProcessos"
                defaultValue={[]}
                render={({ field: { onChange, value } }) => (
                  <CustomInputModal
                    label="Filtrar em massa"
                    value={value ?? []}
                    placeholder="Busque por ID"
                    onConfirm={onChange}
                    onClickOk={validarProcessos}
                    validar={true}
                    style={{ width: "222px" }}
                    placeholderModal="Digite ou copie e cole os IDs dos processos que deseja buscar e tecle ENTER"
                    labelItem="ID Processo"
                  />
                )}
              />
            </Form.Group>
          </InputContainer>
          <InputContainer width={"16%"}>
            <Form.Group>
              <Form.Label>Fornecedor</Form.Label>
              <Controller
                control={control}
                name="idFornecedor"
                render={({ field: { onChange, value } }) => (
                  <DropdownSelect
                    options={optionsFornecedores}
                    title=""
                    selectedValue={value}
                    onSelect={(value) => {
                      onChange(value);
                      onChangeFornecedor(value);
                    }}
                    searchable
                    required
                  />
                )}
              />
            </Form.Group>
          </InputContainer>
          <InputContainer width={"16%"}>
            <Form.Group>
              <Controller
                control={control}
                name="periodoValidacao"
                render={({ field: { onChange } }) => (
                  <DatePickerContainer>
                    <span>Período de reprovação</span>
                    <CustomDatePicker
                      selected={inicioDataValidacao}
                      onChange={(update) => {
                        onChange(update);
                        onChangeDataValidacao(update);
                      }}
                      startDate={inicioDataValidacao}
                      endDate={fimDataValidacao}
                      rangeSelect={true}
                    />
                  </DatePickerContainer>
                )}
              />
            </Form.Group>
          </InputContainer>
          <InputContainer width={"16%"}>
            <Form.Group>
              <ButtonsContainer>
                <Button
                  type="reset"
                  outline
                  variante="primary"
                  style={{ marginRight: "8px", width: "76px" }}
                  onClick={onClickLimpar}
                >
                  Limpar
                </Button>
                <Button type="submit" style={{ width: "76px" }}>
                  Buscar
                </Button>
              </ButtonsContainer>
            </Form.Group>
          </InputContainer>
          <InputContainer style={{ paddingTop: "5px", width: "20%" }}>
            <MaisFiltrosContainer>
              <Form.Group>
                <MaisFiltros
                  limparTudoOnClick={cancelarOnClick}
                  cancelarOnClick={cancelarOnClick}
                  widthModal="lg"
                  showMaisFiltrosDefault={false}
                  handleClickAplicarFiltros={() => {}}
                  submit
                >
                  <InputContainerMaisFiltros>
                    <Form.Group>
                      <Form.Label>Empresa</Form.Label>
                      <Controller
                        control={control}
                        name="idEmpresa"
                        render={({ field: { onChange, value } }) => (
                          <DropdownSelect
                            options={empresasOptions}
                            title=""
                            selectedValue={value}
                            onSelect={onChange}
                            searchable
                            required
                          />
                        )}
                      />
                    </Form.Group>
                  </InputContainerMaisFiltros>
                  <InputContainerMaisFiltros>
                    <Form.Group>
                      <Form.Label>Placa</Form.Label>
                      <Controller
                        control={control}
                        name="placa"
                        render={({ field: { onChange, value } }) => (
                          <CustomInput
                            type="text"
                            placeholder="Busque por placa"
                            style={{ height: "2.2rem" }}
                            onChange={(e) => {
                              mInputPlaca(e);
                              onChange(e);
                            }}
                            value={value ?? undefined}
                          />
                        )}
                      />
                    </Form.Group>
                  </InputContainerMaisFiltros>
                  <InputContainerMaisFiltros>
                    <Form.Group>
                      <Form.Label>Recibo / NF</Form.Label>
                      <Controller
                        control={control}
                        name="numeroNfRecibo"
                        render={({ field: { onChange, value } }) => (
                          <CustomInput
                            type="text"
                            placeholder="Busque pelo nº"
                            style={{ height: "2.2rem" }}
                            onChange={onChange}
                            value={value ?? undefined}
                          />
                        )}
                      />
                    </Form.Group>
                  </InputContainerMaisFiltros>
                </MaisFiltros>
              </Form.Group>
            </MaisFiltrosContainer>
          </InputContainer>
        </Row>
      </Form>
    </FormContainer>
  );
}
